const API_BASE = (process.env.REACT_APP_API_BASE || "http://localhost:5000").replace(
  /\/+$/,
  ""
);

const AUTH_KEYS = [
  "token",
  "authToken",
  "accessToken",
  "userToken",
  "jwtToken",
];

const clearAuthStorage = () => {
  [
    ...AUTH_KEYS,
    "isLoggedIn",
    "user",
    "email",
    "userEmail",
    "user_email",
  ].forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });

  window.dispatchEvent(new Event("auth-state-changed"));
};

export const getToken = () => {
  for (const key of AUTH_KEYS) {
    const value = localStorage.getItem(key) || sessionStorage.getItem(key);

    if (value && String(value).trim()) {
      return String(value).trim();
    }
  }

  return "";
};

export const getAuthHeaders = (isJson = true) => {
  const token = getToken();
  const headers = {};

  if (isJson) {
    headers["Content-Type"] = "application/json";
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const buildUrl = (path = "") => {
  const safePath = String(path || "").trim();

  if (!safePath) return API_BASE;
  if (safePath.startsWith("http")) return safePath;

  return `${API_BASE}${safePath.startsWith("/") ? safePath : `/${safePath}`}`;
};

const safeJson = async (res) => {
  try {
    return await res.json();
  } catch {
    return {};
  }
};

const request = async (path, options = {}) => {
  const res = await fetch(buildUrl(path), options);
  const data = await safeJson(res);

  if (res.status === 401) {
    clearAuthStorage();

    return {
      success: false,
      message: "Session expired. Please login again.",
      status: 401,
    };
  }

  if (!res.ok) {
    return {
      success: false,
      message: data?.message || "Request failed.",
      status: res.status,
      data: data?.data || null,
    };
  }

  return data;
};

export const apiGet = async (path) => {
  return request(path, {
    method: "GET",
    headers: getAuthHeaders(),
  });
};

export const apiPost = async (path, body = {}) => {
  return request(path, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
};

export const apiPut = async (path, body = {}) => {
  return request(path, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
};

export const apiPatch = async (path, body = {}) => {
  return request(path, {
    method: "PATCH",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
};

export const apiDelete = async (path, body = null) => {
  return request(path, {
    method: "DELETE",
    headers: getAuthHeaders(),
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
};

export const apiUpload = async (path, formData) => {
  return request(path, {
    method: "POST",
    headers: getAuthHeaders(false),
    body: formData,
  });
};

export { API_BASE };